import React, { useEffect, useState } from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import ThemeTable from '../component/ThemeTable'
import PurchaseService from '../services/Purchase'
import Loader from '../component/Loader'
import OtherService from "../services/Other";
import NoData from '../component/NoData'
import { Empty } from "antd";

const Task = () => {
  const [loading, setLoading] = useState(true);
  const [taskList, setIsTaskList] = useState([]);
  const [noData, setNoData] = useState(false);
  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };
  useEffect(() => {
    const PurchaseListFetchData = async () => {
      try {
        const token = localStorage.getItem('access_token')
       const responseTaskList = await OtherService.taskList(token)
       if(responseTaskList.error == false){
          if (responseTaskList.data.length > 0)
          {
            const filteredData = responseTaskList.data.map((item, index) => {
              let statusElement;
             
            
              return {
                'Serial No': <div className="text-center">{index + 1}</div>,
                'ID No':item.id,
                'Task':<div className="text-left">{item.task}</div>,
                'Date': <div className="text-center">{formatDate(item.created_at)}</div>,
                // 'Status':statusElement,
                 
    
               
              };
            });
            setIsTaskList(filteredData)
            setLoading(false)
            setNoData(false)
          }
          else{
            setLoading(false)
            setNoData(true)
          }
       }
      else{
        setLoading(false)
        setNoData(true)
      }
       
      }
      catch (e) {
        console.error("e")
      }

    }
    PurchaseListFetchData()
  }, [])
  return (
    <>
      {loading && <Loader />}
      
      <BreadCrumbSecttion pageTitle="My Task List" currentPageName="My Task List" />
      <section className='padTop50'>
        <Container>
          <Row>
           {/* {noData && 
                               <Row>
                                 <Col><NoData /></Col>
                               </Row>
                                } */}
            {noData && <Empty
              // image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No records found"
              classNames={{root: "my-classname"}} styles={{root: {color: "red"}}}
            />           }
            <Col>
              <ThemeTable data={taskList} />
            </Col>
          </Row>
        </Container>
      </section>
     
    </>
  )
}

export default Task
